import { FC, PropsWithChildren } from 'react';
import cx from 'classnames';
import styles from './header-search-bar-suggestions-container.module.scss';

type HeaderSearchBarSuggestionsContainerProps = {
  displayThreeColumns: boolean;
};

export const HeaderSearchBarSuggestionsContainer: FC<
  PropsWithChildren<HeaderSearchBarSuggestionsContainerProps>
> = ({ children, displayThreeColumns }) => (
  <div
    className={cx(`${styles['header-search-bar-suggestions-container']} p-3`, {
      [styles[`header-search-bar-suggestions-container--three-columns`]]:
        displayThreeColumns
    })}
    data-testid="redesigned-suggestion-list"
  >
    {children}
  </div>
);
